module.exports = __webpack_public_path__ + "static/Ide-15b4e3db57b518f3e3d32d453f7ac133.svg";